import { render, staticRenderFns } from "./ITBoard.vue?vue&type=template&id=12334696&scoped=true&"
import script from "./ITBoard.vue?vue&type=script&lang=js&"
export * from "./ITBoard.vue?vue&type=script&lang=js&"
import style0 from "./ITBoard.vue?vue&type=style&index=0&id=12334696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12334696",
  null
  
)

export default component.exports